import React from 'react'
import { connect } from 'react-redux'
import styles from './Diagnosis.module.css';


class PatientHomeAdmissionDiagnosis extends React.Component {

    render() {
        return (
            <div className={styles.diags_wrapper}>
                <div className={styles.diag_header}>Medical Diagnosis</div>
                {Object.keys(this.props.medDiags)
                    .map(id => {
                        const diag = this.props.medDiags[id];
                        return (
                            <div className={styles.diag_wrapper} key={diag.id}>
                                <span className={styles.diag_code}>{diag.diag}</span>
                                <span className={styles.diag_desc} title={diag.desc}>{diag.desc}</span>
                            </div>
                        )
                    })
                }

                <div className={styles.diag_header}>Treatment Diagnosis</div>
                {Object.keys(this.props.trtDiags)
                    .map(id => {
                        const diag = this.props.trtDiags[id];
                        return (
                            <div className={styles.diag_wrapper} key={diag.id}>
                                <span className={styles.diag_code}>{diag.diag}</span>
                                <span className={styles.diag_desc} title={diag.desc}>{diag.desc}</span>
                            </div>
                        )
                    })
                }

            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        medDiags: Object.keys(state.entities.diagnosis)
            .filter(key => { return state.entities.diagnosis[key].epno === ownProps.epno && state.entities.diagnosis[key].type === 'Medical' })
            .sort((a, b) => state.entities.diagnosis[a].position - state.entities.diagnosis[b].position)
            .map(key => state.entities.diagnosis[key]),
        trtDiags: Object.keys(state.entities.diagnosis)
            .filter(key => { return state.entities.diagnosis[key].epno === ownProps.epno && state.entities.diagnosis[key].type === 'Treatment' })
            .sort((a, b) => state.entities.diagnosis[a].position - state.entities.diagnosis[b].position)
            .map(key => state.entities.diagnosis[key]),
    };
}

const connectedPatientHomeAdmissionDiagnosis = connect(mapStateToProps)(PatientHomeAdmissionDiagnosis);
export { connectedPatientHomeAdmissionDiagnosis as PatientHomeAdmissionDiagnosis };
